const responseToLabelMap = {
    '1': "Terror is when you are very scared and don't know what to do and can't think for yourself. All of your actions are automatic.",
    '2': 'Fear is being really scared. You can barely think, and all you can do is react with Fight, Flight, Freeze, or Flock.',
    '3': 'Now being in alarm is more anxious. Being alarm is making us less intelligent than usual, and we become more focused on how we are feeling, as we start to show that we are not calm and we are scared.',
    '4': "Being alert is almost the same as being calm. You may be aware of your surroundings and you may be a little more energized, and you learn best while alert. You're taking on new information with healthy stress. Needed for learning.",
    '5': 'You are feeling relaxed, creative, no worries in the way, and able to really think deeply about things. Information moves from short term memory to long term memory easily.'
}

export const convertResponseToDescription = (response) => {
    response = Math.round(response);
    return responseToLabelMap[response] ?? "Unknown";
}

const ResponseDescription = ({response}) => convertResponseToDescription(response);

export default ResponseDescription;